import { render, staticRenderFns } from "./ThinkingMobile.vue?vue&type=template&id=4ffe4cde&scoped=true"
import script from "./ThinkingMobile.vue?vue&type=script&lang=js"
export * from "./ThinkingMobile.vue?vue&type=script&lang=js"
import style0 from "./ThinkingMobile.vue?vue&type=style&index=0&id=4ffe4cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe4cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
